import { render } from "./apptitude.vue?vue&type=template&id=15b723c7"
import script from "./apptitude.vue?vue&type=script&lang=js"
export * from "./apptitude.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__